export default function FloatingButtons() {
  return (
    <div className="fixed bottom-8 right-8 z-50 flex flex-col gap-4">
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/527131055034"
        target="_blank"
        rel="noopener noreferrer"
        className="group w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-[#ff00ff] to-[#ff00aa] text-white shadow-2xl shadow-[#ff00ff]/50 hover:scale-110 transition-all duration-300 cursor-pointer border-2 border-white/20"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
        <span className="absolute right-20 bg-gradient-to-r from-[#ff00ff] to-[#ff00aa] text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity shadow-lg border border-white/20">
          WhatsApp
        </span>
      </a>

      {/* Facebook Button */}
      <a
        href="https://www.facebook.com/share/1AefDud4bR/"
        target="_blank"
        rel="noopener noreferrer"
        className="group w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-[#00ffff] to-[#0099ff] text-white shadow-2xl shadow-[#00ffff]/50 hover:scale-110 transition-all duration-300 cursor-pointer border-2 border-white/20"
        aria-label="Visitar Facebook"
      >
        <i className="ri-facebook-fill text-3xl"></i>
        <span className="absolute right-20 bg-gradient-to-r from-[#00ffff] to-[#0099ff] text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity shadow-lg border border-white/20">
          Facebook
        </span>
      </a>

      {/* Email Button */}
      <a
        href="mailto:logoideas05@gmail.com"
        className="group w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-[#ff00aa] to-[#ff0066] text-white shadow-2xl shadow-[#ff00aa]/50 hover:scale-110 transition-all duration-300 cursor-pointer border-2 border-white/20"
        aria-label="Enviar Email"
      >
        <i className="ri-mail-line text-3xl"></i>
        <span className="absolute right-20 bg-gradient-to-r from-[#ff00aa] to-[#ff0066] text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity shadow-lg border border-white/20">
          Email
        </span>
      </a>
    </div>
  );
}
